module.exports = __webpack_public_path__ + "static/media/Lydløs.8ab02597.m4a";